import React from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Button,
  Chip,
  Stack,
  alpha,
  useTheme,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Link } from "react-router-dom";
import {
  Work as WorkIcon,
  CheckCircle as CheckCircleIcon,
  Schedule as ScheduleIcon,
  Payment as PaymentIcon,
  TrendingUp as TrendingUpIcon,
  Star as StarIcon,
} from "@mui/icons-material";
import SupportLayout from "../Support/SupportLayout";

const CleanerJobs = () => {
  const theme = useTheme();

  const benefits = [
    { icon: <WorkIcon />, title: "More Job Opportunities", desc: "Get discovered by Airbnb hosts needing cleaners" },
    { icon: <ScheduleIcon />, title: "Flexible Schedule", desc: "Accept jobs that fit your availability" },
    { icon: <TrendingUpIcon />, title: "Repeat Host Clients", desc: "Build recurring relationships for stable income" },
    { icon: <PaymentIcon />, title: "Easy Payments", desc: "Get paid weekly with automatic deposits" },
    { icon: <StarIcon />, title: "Build Your Reputation", desc: "Earn ratings and become a preferred cleaner" },
  ];

  const stats = [
    { value: "$35-75", label: "Per Cleaning" },
    { value: "500+", label: "Active Cleaners" },
    { value: "4.9★", label: "Cleaner Rating" },
    { value: "Weekly", label: "Payouts" },
  ];

  return (
    <SupportLayout
      title="Get More Cleaning Jobs Near You"
      category="Services"
      subtitle="Join FreshSweeper to connect with Airbnb hosts looking for reliable cleaners, recurring work, and trusted professionals."
      breadcrumbs={[
        { label: "Services", link: "/services" },
        { label: "Cleaner Jobs" },
      ]}
    >
      {/* Benefits Grid */}
      <Grid container spacing={4} sx={{ mb: 6 }}>
        {benefits.map((benefit, idx) => (
          <Grid item xs={12} md={4} key={idx}>
            <Card sx={{ height: "100%", p: 3, borderRadius: 3 }}>
              <Box sx={{ color: theme.palette.primary.main, mb: 2 }}>
                {React.cloneElement(benefit.icon, { sx: { fontSize: 40 } })}
              </Box>
              <Typography variant="h6" fontWeight="700" gutterBottom>
                {benefit.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {benefit.desc}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Stats */}
      <Grid container spacing={3} sx={{ mb: 6 }}>
        {stats.map((stat, idx) => (
          <Grid item xs={6} md={3} key={idx}>
            <Card sx={{ textAlign: "center", p: 3 }}>
              <Typography variant="h4" fontWeight="800" color="primary.main">
                {stat.value}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {stat.label}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Testimonial */}
      <Card sx={{ mb: 6, p: 4, bgcolor: alpha(theme.palette.primary.main, 0.02) }}>
        <Typography variant="body1" sx={{ fontStyle: "italic", mb: 2 }}>
          "FreshSweeper helped me find consistent Airbnb turnover work. I'm now earning $800+ per week with repeat hosts."
        </Typography>
        <Typography variant="subtitle2" fontWeight="700">— Maria, Professional Cleaner</Typography>
      </Card>

      {/* CTA */}
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Button
          variant="contained"
          size="large"
          startIcon={<WorkIcon />}
          sx={{ borderRadius: "50px", px: 5, py: 1.5 }}
        >
          Join as Cleaner
        </Button>
      </Box>
    </SupportLayout>
  );
};

export default CleanerJobs;